import { useState } from 'react';
import { Popover } from '@mui/material';
import { BlockPicker } from 'react-color';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeDropper } from '@fortawesome/pro-solid-svg-icons';
import * as styles from './ProgramColorField.css';

const PALETTE = [
  '#6367EF',
  '#7C7FD8',
  '#B390CF',
  '#BF6502',
  '#D4832A',
  '#F8B24C',
  '#5F5041',
  '#8D7862',
  '#C7A887',
  '#D85265',
  '#DB7D8B',
  '#DE919D',
  '#904D3D',
  '#A66B5D',
  '#C19085',
  '#57773A',
  '#6C8650',
  '#90A064',
  '#378582',
  '#63A9A2',
  '#79BAAE',
  '#3C6799',
  '#5F91C9',
  '#8ABBEC',
  '#43924A',
  '#66B16D',
  '#88CC8E',
  '#455057',
  '#6D7479',
  '#9CA1A5',
];

type ProgramColorFieldProps = {
  value: string;
  onChange: (hex: string) => void;
  disabled?: boolean;
};

export const ProgramColorField = ({
  value,
  onChange,
  disabled,
}: ProgramColorFieldProps) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const isOpen = anchor !== null;

  const displayValue = `#${value}`;

  return (
    <div className={styles.row}>
      <button
        type="button"
        className={styles.swatch}
        style={{ backgroundColor: displayValue }}
        onClick={(e) => setAnchor(e.currentTarget)}
        disabled={disabled}
        aria-label="Pick color"
      >
        <FontAwesomeIcon icon={faEyeDropper} className={styles.swatchIcon} />
      </button>
      <button
        type="button"
        className={styles.hexButton}
        onClick={(e) => setAnchor(e.currentTarget)}
        disabled={disabled}
        data-testid="color-picker"
      >
        {displayValue}
      </button>
      <Popover
        open={isOpen}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { mt: 1, overflow: 'visible' } } }}
      >
        <BlockPicker
          color={displayValue}
          colors={PALETTE}
          triangle="hide"
          onChange={(c) => onChange(c.hex.replace(/^#/, ''))}
          onChangeComplete={() => setAnchor(null)}
        />
      </Popover>
    </div>
  );
};
